
<div id="map" [ngClass]="isEmbed == true ? 'embedmap' : 'notembedmap'"> </div>